module.exports = __webpack_public_path__ + "assets/img/y_10.90a43322.png";